import { AlertCircle, ArrowLeft, LogIn, ShieldCheck } from 'lucide-react'
import inlogFilm from '../assets/inlog.mp4'
import inlogBeeld from '../assets/inlog.jpg'
import { Logo } from './ui'

/* ===========================================================================
 *  Het scherm voor wie nog niet binnen is
 *
 *  Hetzelfde als het inlogscherm van het dashboard (components/Login.tsx
 *  daar): links de film van de wasstraat met het logo, rechts het formulier
 *  op licht. Alleen staat er hier geen formulier maar één knop -- er is hier
 *  geen wachtwoord, want hier is geen wachtwoordenlijst. Je logt in bij
 *  het dashboard en komt terug.
 *
 *  Wie liever minder beweging wil (een instelling van het systeem), krijgt
 *  het stilstaande beeld in plaats van de film.
 * =========================================================================== */

const UITLEG: Record<string, string> = {
  'geen-toegang':
    'Je bent ingelogd, maar Projects is alleen voor ontwikkelaars en management. '
    + 'Hoort dat bij jou wel zo te zijn, vraag het dan aan iemand van management: '
    + 'die kan het recht in het dashboard aan je geven.',
  'niet-na-te-kijken':
    'Je toegang kon even niet worden nagekeken. Dat ligt niet aan jou; probeer '
    + 'het over een minuut opnieuw.',
  'geen-briefje': 'De link waarmee je hier kwam was niet compleet. Probeer het opnieuw vanaf het dashboard.',
  'briefje-klopt-niet':
    'Het toegangsbewijs klopte niet. Dat gebeurt als een link is aangepast of '
    + 'doorgestuurd. Ga terug naar het dashboard en gebruik de knop daar.',
  'briefje-verlopen': 'Het toegangsbewijs was verlopen — die is maar een minuut geldig. Klik hieronder om het opnieuw te doen.',
  'briefje-al-gebruikt': 'Dit toegangsbewijs was al gebruikt; hij werkt één keer. Meld je hieronder gewoon opnieuw aan.',
  'reis-verlopen': 'Het duurde te lang tussen het beginnen en het inloggen. Probeer het nog een keer.',
  'reis-klopt-niet': 'Er ging iets mis bij het terugkomen van het dashboard. Begin opnieuw; blijft het gebeuren, meld het dan.',
  'geen-code': 'Het dashboard stuurde geen antwoord mee. Probeer het opnieuw.',
  'dashboard-onbereikbaar': 'Het dashboard was even niet bereikbaar. Probeer het over een minuut nog eens.',
  'inloggen-mislukt':
    'Het dashboard wilde je niet doorlaten. Kun je daar wel inloggen? Zo ja, meld '
    + 'dit dan — dan zit het aan onze kant.',
  'niet-ingericht': 'Projects is nog niet helemaal ingesteld. Dit is niets wat jij kunt oplossen; geef het door.',
}

const beweegt = (() => {
  try { return !window.matchMedia('(prefers-reduced-motion: reduce)').matches } catch { return true }
})()

export default function Poort({ fout }: { fout: string | null }) {
  const tekst = fout ? (UITLEG[fout] ?? 'Het inloggen is niet gelukt.') : null
  const heen = location.pathname !== '/' ? location.pathname + location.search : ''

  return (
    <div className="inlog">
      <section className="inlog-beeld" aria-hidden="true">
        {beweegt
          ? <video className="inlog-film" src={inlogFilm} poster={inlogBeeld} autoPlay muted loop playsInline preload="metadata" tabIndex={-1} />
          : <img className="inlog-film" src={inlogBeeld} alt="" />}
        <div className="inlog-sluier" />
        <div className="inlog-beeld-tekst">
          <Logo breedte={200} />
          <p className="inlog-zin">Projecten, sprints en code van Truckwash 1 Group.</p>
        </div>
      </section>

      <section className="inlog-kant">
        <div className="inlog-form">
          <div className="inlog-merk-klein"><Logo breedte={160} /></div>
          <h1 className="inlog-titel">Projects</h1>
          <p className="inlog-lead">
            Borden, sprints, whiteboards en de repo's, voor ontwikkelaars en management.
            Je logt in met je account van het dashboard.
          </p>

          {tekst && (
            <div className="inlog-melding" role="alert">
              <AlertCircle size={16} />
              <span>{tekst}</span>
            </div>
          )}

          <a className="inlog-knop" href={`/aanmelden${heen ? `?heen=${encodeURIComponent(heen)}` : ''}`}>
            <LogIn size={17} />
            Inloggen via het dashboard
          </a>

          <p className="inlog-voet"><ShieldCheck size={14} /> Je wachtwoord komt hier niet langs</p>
          <a className="inlog-terug" href="https://truckwash-workspace.com/"><ArrowLeft size={13} /> Naar het dashboard</a>
        </div>
      </section>
    </div>
  )
}
